import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { SessionSliceType, refreshTokenUpdateProps } from './types';

const initialState: SessionSliceType = {
  agentId: null,
  entitlements: {},
  features: [],
  token: null,
  accessToken: '',
  refreshToken: '',
  userLoggedIn: false,
  missingPii: [],
  /* `null` = not yet known. Distinct from a stamped timestamp, and the tour's
     gate treats both null and '' as "no previous visit". */
  lastVisitedAt: null,
  userOffline: false,
  sessionId: '',
  currentReport: null,
  migrateReport: false,
};

const sessionSlice = createAppSlice({
  name: 'session',
  initialState,
  reducers: {
    setSessionSlice(state, action: PayloadAction<SessionSliceType>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    refreshTokenUpdate(state, action: PayloadAction<refreshTokenUpdateProps>) {
      const { accessToken, refreshToken } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
    },
    setMissingPii(state, action: PayloadAction<string[]>) {
      state.missingPii = action.payload;
    },
    addTuidVerified(state) {
      state.entitlements['itps:verified'] = ['tuid'];
    },
    addIdauthVerified(state) {
      state.entitlements['itps:verified'] = ['idauth'];
    },
    setCurrentReport(state, action: PayloadAction<string | null>) {
      state.currentReport = action.payload;
    },
    setPlaidOauthState(
      state,
      action: PayloadAction<{ linkToken: string; itemId: string | null }>,
    ) {
      state.plaidOauthLinkToken = action.payload.linkToken;
      state.plaidOauthItemId = action.payload.itemId;
    },
    clearPlaidOauthState(state) {
      state.plaidOauthLinkToken = null;
      state.plaidOauthItemId = null;
    },
    userSignOut() {
      return initialState;
    },
  },
});

export const {
  setSessionSlice,
  userSignOut,
  refreshTokenUpdate,
  setMissingPii,
  addTuidVerified,
  addIdauthVerified,
  setCurrentReport,
  setPlaidOauthState,
  clearPlaidOauthState,
} = sessionSlice.actions;
export default sessionSlice.reducer;
